/**
 * Value object representing a summary card block data
 *
 * Encapsulates summary card data with validation and business rules.
 * Immutable by design to ensure data integrity.
 *
 * @example
 * const summaryCardBlockData: SummaryCardBlockData = {
 *   value: '100',
 *   secondaryValue: '56.2',
 * };
 */
export type SummaryCardBlockData = Readonly<{
  value: string;
  secondaryValue?: string | null;
}>;

/**
 * Factory function to create a summary card block data
 *
 * @param props - The properties to create the summary card block data
 * @returns {SummaryCardBlockData} The created summary card block data
 *
 * @example
 * const summaryCardBlockData: SummaryCardBlockData = createSummaryCardBlockData({
 *   value: '100',
 *   secondaryValue: '56.2',
 * });
 */
export const createSummaryCardBlockData = (props: SummaryCardBlockData): SummaryCardBlockData => {
  if (!props.value) {
    throw new Error('Value is required');
  }

  return Object.freeze(props);
};
